<template>
    <div id="page" class="content">
        <b-container id="main" class="section">
            <b-row align-v="center">
                <b-col cols="12" lg="12">
                    <div class="subsection">
                        <div class="view">

                            <div class="text-center">
                                <h1 class="pricing__title mb-1">{{ $t('pages.companies.titlePackage') }}</h1>

                                <p class="pricing__disclaimer mb-5">{{ $t('pages.companies.titleDisclaimer') }}</p>

                                <div class="banner mb-5">
                                    <div class="banner__icon">
                                        <font-awesome-icon :icon="['fas', 'burst']"  size="2x" />
                                    </div>
                                    <p class="alone">{{ $t('pages.companies.bannerSubscriptionText') }} = <strong>{{ $t('pages.companies.bannerSubscriptionMonth') }}</strong></p>
                                </div>
                            </div>

                            <b-card-group deck class="mb-5">
                                <b-card
                                    :title="$tc('pages.companies.planCredits', 1)"
                                    sub-title="999 Kč"
                                    class="pricing__item"
                                    sub-title-text-variant=""
                                >
                                    <template #default>
                                        <ul>
                                            <li>{{ $tc('pages.companies.planOffers', 1) }}</li>
                                            <li>{{ $tc('pages.companies.planDays', 14) }}</li>
                                            <li>{{ $t('pages.companies.planNoExtra') }}</li>
                                        </ul>
                                    </template>
                                    <template #footer>
                                        <b-button variant="primary" class="button_blue" href="https://app.recruitis.io/zadavatel" target="_blank">{{ $t('pages.companies.btnStart') }}</b-button>
                                    </template>
                                </b-card>
                                <b-card
                                    :title="$tc('pages.companies.planCredits', 3)"
                                    sub-title="1950 Kč"
                                    class="pricing__item"
                                    sub-title-text-variant=""
                                >
                                    <template #default>
                                        <ul>
                                            <li>{{ $tc('pages.companies.planOffers', 3) }}</li>
                                            <li>{{ $tc('pages.companies.planDays', 30) }}</li>
                                            <li>{{ $t('pages.companies.planExtra') }}</li>
                                        </ul>
                                    </template>
                                    <template #footer>
                                        <b-button variant="primary" class="button_blue" href="https://app.recruitis.io/zadavatel" target="_blank">{{ $t('pages.companies.btnStart') }}</b-button>
                                    </template>
                                </b-card>
                                <b-card
                                    :title="$tc('pages.companies.planCredits', 6)"
                                    sub-title="2700 Kč"
                                    class="pricing__item"
                                    sub-title-text-variant=""
                                >
                                    <template #default>
                                        <ul>
                                            <li>{{ $tc('pages.companies.planOffers', 6) }}</li>
                                            <li>{{ $tc('pages.companies.planDays', 30) }}</li>
                                            <li>{{ $t('pages.companies.planExtra') }}</li>
                                        </ul>
                                    </template>
                                    <template #footer>
                                        <b-button variant="primary" class="button_blue" href="https://app.recruitis.io/zadavatel" target="_blank">{{ $t('pages.companies.btnStart') }}</b-button>
                                    </template>
                                </b-card>
                            </b-card-group>

                            <div class="text-center">
                                <div class="banner need-more mb-5">
                                    <div class="banner__icon">
                                        <font-awesome-icon :icon="['fas', 'lightbulb']" size="2x" />
                                    </div>
                                    <h5>{{ $t('pages.companies.bannerNeedMoreTitle') }}:</h5>
                                    <p>{{ $t('pages.companies.bannerNeedMoreText') }}</p>
                                    <div class="banner__phone">
                                        <a href="tel:+420724500898">+420&nbsp;724&nbsp;500&nbsp;898</a>
                                    </div>
                                </div>
                            </div>

                            <h2 class="pricing__subtitle mb-4">{{ $t('pages.companies.titleServices') }}</h2>

                            <div class="pricing__service">
                                <h5>{{ $t('pages.companies.serviceTopTitle') }}</h5>
                                <p>{{ $t('pages.companies.serviceTopText') }}</p>
                                <div class="price">
                                    <span>600&nbsp;Kč</span>
                                </div>
                            </div>
                            <div class="pricing__service">
                                <h5>{{ $t('pages.companies.servicePartTimeJobTitle') }}</h5>
                                <p>{{ $t('pages.companies.servicePartTimeJobText') }}</p>
                                <div class="price">
                                    <span>{{ $t('pages.companies.servicePartTimeJobPrice') }}</span>
                                </div>
                            </div>
                            <div class="pricing__service mb-5">
                                <h5>{{ $t('pages.companies.serviceRecruitisTitle') }}</h5>
                                <p>{{ $t('pages.companies.serviceRecruitisText1') }}<br>{{ $t('pages.companies.serviceRecruitisText2') }}</p>
                                <div class="price">
                                    <a href="https://recruitis.io/#price" target="_blank">{{ $t('pages.companies.serviceRecruitisPricing') }}</a>
                                </div>
                                <div class="extra">
                                    <b-button variant="primary" class="button_blue" href="https://recruitis.io/#contact" target="_blank">{{ $t('pages.companies.serviceRecruitisBtnTry') }}</b-button>
                                </div>
                            </div>

                            <h2 class="pricing__subtitle mb-3 text-center">{{ $t('pages.companies.titleSupport') }}</h2>

                            <div class="pricing__support">
                                <div class="support__item">
                                    <font-awesome-icon :icon="['fa', 'phone']" size="2x" />
                                    <p>
                                        <a href="tel:+420724500898">+420&nbsp;724&nbsp;500&nbsp;898</a>
                                        <span>(9:00&nbsp;-&nbsp;16:00)</span>
                                    </p>
                                </div>
                                <div class="support__item">
                                    <font-awesome-icon :icon="['fa', 'envelope']" size="2x" />
                                    <p><a href="mailto:podpora@recruitis.io">{{ $t('pages.companies.supportWriteUs') }}</a></p>
                                </div>
                            </div>

                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
    layout: "with_page_title",
    head() {
        return {
            title: this.$t("pages.companies.title"),
        };
    },
    created() {
        this.$store.dispatch("page/setTitle", this.$t("pages.companies.title"));
    },
};
</script>
